<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Filtre et recherche</h3>
            <button type="button"
                    class="btn btn-xs btn-default btn-flat margin pull-right"
                    style="margin-top: 0;margin-bottom: 0;"
                    @click="resetFilter()"
            >
              Réinitialiser les filtres
            </button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <list-select-club
                  :clubsLicenciesUniquement="false"
                  title="Filtrer par club"
                  :showOptionTousLesClubs="true"
                  :clubPreSelected="clubSelectedForFilter"
                  :reset="reset"
                  @clubSelected="updateClubSelected"
                ></list-select-club>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="montantOptions">
                        Montant
                      </label>
                      <select name="montantOptions" id="montantOptions" class="pull-right form-control"
                              v-model="montantOptions">
                        <option value="0"></option>
                        <option value="1">Egal à</option>
                        <option value="2">Plus petit que</option>
                        <option value="3">Plus grand que</option>
                        <option value="4">Entre</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-show="montantOptions != 0 && montantOptions!=null"
                         :class="{ 'has-error': showErrorMontantDe }">
                      <label for="MontantDe">&nbsp;</label>
                      <div class="input-group">
                        <span class="input-group-addon">€</span>
                        <input type="text" name="montant" class="form-control" id="MontantDe"
                               v-model="montant" placeholder="">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group" v-show="montantOptions == 4  && montantOptions!=null "
                         :class="{ 'has-error': showErrorMontantEt }">
                      <label for="MontantEt">&nbsp;</label>
                      <div style="float:left">Et</div>
                      <div class="input-group">
                        <span class="input-group-addon">€</span>
                        <input type="text" name="montant_limite" id="MontantEt" v-model="montantLimite"
                               class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 " id="dataRange">
                <div class="form-group input-daterange">
                  <label>Du:</label>
                  <div class="input-group date ">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="periodeDu" v-model="periodeDu"
                           class="form-control pull-right datepicker" id="datepicker1">
                  </div>
                  <!-- /.input group -->
                </div>
                <div class="form-group input-daterange">
                  <label>Au:</label>
                  <div class="input-group date ">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <input type="text" name="periodeAu" v-model="periodeAu"
                           class="form-control pull-right datepicker" id="datepicker2">
                  </div>
                  <!-- /.input group -->
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="montantOptions">
                    Statut
                  </label>

                  <select name="montantOptions" id="statut" class="pull-right form-control"
                          v-model="statutRecherche">
                    <option value="0"></option>
                    <option
                      v-for="statut in getStatusOrder"
                      :value="statut.id"
                    > {{statut.statut}}
                    </option>
                  </select>
                </div>
              </div>
<!--              <div class="col-md-1">-->
<!--                <div class="form-group">-->
<!--                  <label for="createByMyABFT">-->
<!--                    Créé via MyABFT-->
<!--                  </label>-->

<!--                  <select name="createByMyABFT" id="generate_by_myabft" class="pull-right form-control"-->
<!--                          v-model="generate_by_myabft">-->
<!--                    <option value="0">NON</option>-->
<!--                    <option value="1">OUI</option>-->
<!--                    <option value="2">Pas d'importance</option>-->
<!--                  </select>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </div>
          <div class="box-footer">
            <input type="submit" @click.prevent="searchOrders()" value="Rechercher" class="btn btn-primary pull-right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <b-col md="9" class="my-1">
              <h3 class="box-title">Listing des bons de commande: {{pagination_meta.total}} résultat{{pagination_meta.total>1 ?
                's':''}}</h3>
            </b-col>
            <b-col md="3" class="my-1">
              <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
            </b-col>

          </div>
          <div class="box-body">
            <b-table
              id="tableListingAllOrders"
              v-if="!loadingListingOrder && listingOrders.length>0"
              responsive bordered striped hover
              :items="listingOrders"
              :filter="filter"
              :fields="columnsListingOrder"
              :per-page="pagination_meta.per_page"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :empty-text="'Aucun résultat'"
              :empty-filtered-text="'Aucun résultat'"
              foot-clone
              show-empty
              @filtered="onListingFiltered"
            >
              <template slot="actions" slot-scope="row">
                <router-link
                  class="btn btn-default padding2"
                  :to="{ name: 'Liste_commandes_myabft', params: { order_id: row.item.id }}">
                  <i class="glyphicon glyphicon-pencil"></i>
                </router-link>
              </template>
              <template slot="id" slot-scope="row">
                <router-link
                  :to="{ name: 'Liste_commandes_myabft', params: { order_id: row.item.id }}">
                  <span v-if="row.item.generate_by_myabft">MyABFT - </span>
                  Bon de commande n°{{row.item.id | idFormat}}

                </router-link>
              </template>
              <template slot="statut" slot-scope="data">
                                <span
                                  :class="getClassNameOrder(data.item.statut)">
                                    {{data.item.statut}}
                                </span>
              </template>
              <template slot="products" slot-scope="data">
<!--                {{data.item.products_count}} {{data.item.products_count>1 ? " produits" : " produit"}} :-->
<!--                <ul>-->
                  <div v-for="(product,key) in data.item.products_types">
                    {{getNameProduct(key,product)}}: {{product}}
                  </div>
<!--                </ul>-->
              </template>
              <template slot="total" slot-scope="data">
                {{data.item.total | idFormat}}€
              </template>
              <template slot="mode_payement" slot-scope="data">
                {{data.item.mode_payement.mode }}
              </template>
              <template slot="mode_livraison" slot-scope="data">
                {{data.item.mode_livraison.mode }}
              </template>
              <template slot="club" slot-scope="data">
                <router-link
                  :to="{ name: 'Club', params: { club_id: data.item.id_club }}">
                  N°{{data.item.num_club}} - {{data.item.club}}
                </router-link>
<!--                If club is not licencied, show warning icon -->
                <span v-if="data.item.club_licencie==false" class="fa fa-exclamation-triangle text-red" title="Club non-licencie"></span>
              </template>
            </b-table>
            <b-pagination size="md"
                          @change="changePage"
                          :total-rows="pagination_meta.total"
                          v-model="pagination_meta.current_page"
                          :per-page="pagination_meta.per_page">
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import {mapGetters, mapActions} from 'vuex'
  import {ErrorBag} from 'vee-validate';
  import vSelect from '../../Communs/vSelect/index'
  import ListSelectClub from '../../Communs/listeSelectClub'
  import '../../../utils'

  require('../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
  require('../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')

  var _ = require('underscore')
  var moment = require('moment')

  export default {
    props: {
      refreshListing: {
        type: Boolean,
      },
      clubPreSelected: {
        type: Number,
        default: -1,
      }
    },
    data() {
      return {
        clubSelectedForFilter: -1,
        sortBy: null,
        sortDesc: null,
        filter: null,
        listingOrders: [],
        loadingListingOrder: true,
        isBusy: false,
        current_page: 1,
        periodeDu: null,
        periodeAu: null,
        montant: null,
        statutRecherche: 0,
        montantLimite: null,
        montantOptions: null,
        reset: false,
        showErrorMontantEt: false,
        showErrorMontantDe: false,
        generate_by_myabft: 1,
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 20,
          to: 1,
          total: 1
        },
        columnsListingOrder: [
          {
            label: 'Date',
            key: 'date',
            sortable: true,
          },
          {
            label: 'Numéro',
            key: 'id',
            sortable: true,
          },
          {
            label: 'Club',
            key: 'club',
            sortable: true,
          },
          {
            label: 'Produits',
            key: 'products',
            sortable: false,
          },
          {
            label: 'Statut',
            key: 'statut',
            sortable: true,
          },
          {
            label: 'Moyen de payement',
            key: 'mode_payement',
            sortable: true,
          },
          {
            label: 'Moyen de livraison',
            key: 'mode_livraison',
            sortable: true,
          },
          {
            label: 'Total',
            key: 'total',
            sortable: false,
          },
          {
            label: 'Actions',
            key: 'actions',
          },
        ]
      }
    },
    computed: {
      ...mapGetters({
        getRoute: 'getRoute',
        getStatusOrder: 'getStatusOrder',
        getModesPayement:'getModesPayement',
        getModesLivraison:'getModesLivraison',
      }),
    },
    mounted: function () {
      var these = this
      if (this.clubPreSelected > 0)
        this.clubSelectedForFilter = this.clubPreSelected

      this.getTableListingOrder();
      this.$nextTick(function () {
        $('.input-daterange1').datepicker({
          autoclose: true,
          language: 'fr',
        }).on("changeDate", function (e) {
          these.periodeDu = $('#datepicker1').val()
          these.periodeAu = $('#datepicker2').val()
        });
      })
    },
    created() {
    },
    beforeRouteUpdate(to, from, next) {
      this.getTableListingOrder();
      next()
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.loadStatutsOrders()

      })
    },
    watch: {
      'montant': function (val) {
        this.constructSearchRequest()
      },
      'sortBy': function (val) {
        this.getTableListingOrder()
      },
      'sortDesc': function (val) {
        this.getTableListingOrder()
      },
      'montantLimite': function (val) {
        this.constructSearchRequest()
      },
      'montantOptions': function (val) {
        if (val == 0) {
          this.montant = null
          this.montantLimite = null
        }
        this.constructSearchRequest()
      },
      'periodeDu': function (val) {
        this.constructSearchRequest()
      },
      'periodeAu': function (val) {
        this.constructSearchRequest()
      },
      'generate_by_myabft': function (val) {
        this.constructSearchRequest()
      },
      'clubSelectedForFilter': function (val) {
        this.constructSearchRequest()
      },
      'clubPreSelected': function (val) {
        this.clubSelectedForFilter = val
      },
      'refreshListing':function() {
        this.getTableListingOrder()
      }
    },
    components: {
      vSelect,
      ListSelectClub,
    },
    methods: {
      ...mapActions({
        setStatusOrder: 'setStatusOrder',
      }),
      getNameProduct: function (meta,count) {
        switch (meta) {
          case 'renew':
            return "Renouvellement" + (count>1 ? "s" : "")
          case 'duplicata':
            return "Duplicata" + (count>1 ? "s" : "")
          case 'licence_club':
            return count>1 ? "Licences club" : "Licence club"
          case 'new':
            return "Nouveau" + (count>1 ? "x" : "")
          default: return "Non-répertorié" + (count>1 ? "s" : "")
        }
      },
      getClassNameOrder: function (statut) {
        return this.$getClassNameRecap(statut)
      },
      onListingFiltered(filteredItems) {
        if (this.filter != "") {
          this.pagination_meta.total = filteredItems.length
          this.pagination_meta.currentPage = 1
        } else {
          this.getTableListingOrder();
        }
      },

      searchOrders: function () {
        this.sortDesc = null;
        this.sortBy = null;
        this.getTableListingOrder();
      },
      resetFilter: function () {
        this.clubSelectedForFilter = null;
        this.periodeDu = null;
        this.periodeAu = null;
        this.montant = null;
        this.montantLimite = null;
        this.montantOptions = null;
        this.showErrorMontantEt = false;
        this.showErrorMontantDe = false;
        this.reset = !this.reset;
      },
      constructSearchRequest: function () {
        var objectTemp = {}
        if (this.montant != '' && this.montant != null)
          objectTemp.montant = this.montant
        if (this.montantOptions != '' && this.montantOptions != null)
          objectTemp.montantOptions = this.montantOptions
        if (this.montantLimite != '' && this.montantLimite != null)
          objectTemp.montant_limite = this.montantLimite
        if (this.periodeDu != '' && this.periodeDu != null)
          objectTemp.periodeDu = this.periodeDu
        if (this.periodeAu != '' && this.periodeAu != null)
          objectTemp.periodeAu = this.periodeAu
        if (this.clubSelectedForFilter != '' && this.clubSelectedForFilter > 0 && this.clubSelectedForFilter != null)
          objectTemp.clubSelectedForFilter = this.clubSelectedForFilter

        if (this.statutRecherche != 0 && this.statutRecherche != null)
          objectTemp.statut = this.statutRecherche
        if (this.generate_by_myabft != 2 && this.generate_by_myabft != null)
          objectTemp.generate_by_myabft = this.generate_by_myabft

        if (this.pagination_meta.per_page != 0 && this.pagination_meta.per_page != null)
          objectTemp.perPage = this.pagination_meta.per_page
        if (this.sortBy != null) {
          let sortDesc = this.sortDesc != null ? this.sortDesc == true ? "asc" : "desc" : "desc"
          objectTemp.sort = this.sortBy + "|" + sortDesc
        }
        if (this.pagination_meta.current_page != 0 && this.pagination_meta.current_page != null)
          objectTemp.currentPage = this.pagination_meta.current_page

        return (objectTemp);
      },
      changePage: function (e) {
        this.pagination_meta.current_page = e
        this.getTableListingOrder();
      },
      updateClubSelected: function (value) {
        this.clubSelectedForFilter = value.id;
      },
      currentYear: function () {
        return moment().year();
      },
      getTableListingOrder: function () {
        this.loadingListingOrder = true;
        this.isBusy = true
        let self = this
        // debugger;
        this.$http.post(self.getRoute('Secretariat.ordermyabft.getAll'), this.constructSearchRequest())
          .then((response) => {
            self.listingOrders = response.body.data
            self.pagination_meta = response.body.meta
            self.loadingListingOrder = false;
            self.$root.$emit('bv::refresh::table', 'tableListingAllOrders');
          }, (response) => {
            self.listingOrders = []
            self.$root.$emit('bv::refresh::table', 'tableListingAllOrders');
          });
      },
      isTableListingOrderLoading: function (force = false) {
        if (force)
          return true
        return this.loadingListingOrder;
      },
      console: function (event) {
        console.log(event);
      },
      formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
        if (value == null) return ''
        return moment(value, fmtIn).format(fmtOut)
      },
      loadStatutsOrders: function () {

        let self = this
        console.log(self.getRoute('Secretariat.ordermyabft.getAllStatutsOrders'))
        this.$http.get(self.getRoute('Secretariat.ordermyabft.getAllStatutsOrders')).then((response) => {
          this.setStatusOrder(response.body)
        }, (response) => {
        });
      },
    },
    filters: {
      idFormat: function (value) {
        return new Intl.NumberFormat("de-DE").format(value)
      }
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/Secretariat/MyABFT/ListingOrder.vue